import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
var SIZES = {
  small: {
    font: -2
  },
  medium: {
    font: -1
  }
};
var activeStyles = css(["background-color:", ";color:#fff;&:hover{background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primaryD;
});
export var ChipBlock = styled.div.withConfig({
  displayName: "partials__ChipBlock",
  componentId: "sc-tts2ha-0"
})(["display:inline-block;flex-shrink:0;height:30px;padding:4px 8px;border-radius:16px;margin:3px;cursor:pointer;background-color:", ";", " transition:0.1s ease-in;&:hover{background-color:", ";}", " svg{margin-left:4px;vertical-align:middle;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiL;
}, function (_ref4) {
  var size = _ref4.size;
  return getFont(SIZES[size].font);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.ui;
}, function (_ref6) {
  var isActive = _ref6.isActive;
  return isActive && activeStyles;
});
export var ActionIcon = styled.span.withConfig({
  displayName: "partials__ActionIcon",
  componentId: "sc-tts2ha-1"
})(["margin:auto 0 auto 4px;cursor:pointer;"]);